import React from 'react'

import { HBox, Wrapper } from 'src/ui/layout'
import { Hero } from 'src/ui/organisms'
import { Body, Header } from 'src/ui/typography'
import { EVENTS, SPACE, SPORT, TRADITION } from './constants'

type Props = {
  images: TImages
}

export const Office: React.FC<Props> = ({ images }) => (
  <>
    <Wrapper>
      <Header size="h4" as="h2">
        Офис в Калининграде
      </Header>
    </Wrapper>
    <HBox />
    <Hero
      background={images['office-space']}
      title="Пространство для продуктивной работы"
      titleSize="h5"
      textHeight={224}
      objectPosition="bottom center"
    >
      <HBox height={24} />
      <Body>{SPACE}</Body>
    </Hero>
    <HBox height={48} />
    <Hero
      background={images['tradition']}
      title="Вкусные традиции"
      titleSize="h5"
      textHeight={224}
    >
      <HBox height={24} />
      <Body>{TRADITION}</Body>
    </Hero>
    <HBox height={48} />
    <Hero
      background={images['sport']}
      title="Спорт и активный образ жизни"
      titleSize="h5"
      textHeight={224}
    >
      <HBox height={24} />
      <Body>{SPORT}</Body>
    </Hero>
    <HBox height={48} />
    <Hero
      background={images['events']}
      title="Мероприятия для кодеров"
      titleSize="h5"
      textHeight={224}
    >
      <HBox height={24} />
      <Body>{EVENTS}</Body>
    </Hero>
    <HBox height={48} />
  </>
)
